// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2BGcT","inner":"Footer_inner__3Z1mG"};